<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import TabCliente from '@/views/cadastros/cliente/cliente/list/TabCliente.vue';
import TabComercial from '@/views/cadastros/cliente/cliente/list/TabComercial.vue';
import TabContato from '@/views/cadastros/cliente/cliente/list/TabContato.vue';
import TabDocumento from '@/views/cadastros/cliente/cliente/list/TabDocumento.vue';
import TabEndereco from '@/views/cadastros/cliente/cliente/list/TabEndereco.vue';
import TabFiscal from '@/views/cadastros/cliente/cliente/list/TabFiscal.vue';
import TabRepresentante from '@/views/cadastros/cliente/cliente/list/TabRepresentante.vue';

export default {
  components: {
    TabCliente,
    TabComercial,
    TabContato,
    TabDocumento,
    TabEndereco,
    TabFiscal,
    TabRepresentante,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        clienteid: '',
        clienteidrep: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      const isValid = await this.$refs.refFormData.validate();
      if (isValid) {
        this.$emit('ok', this.dataForm);
        this.$bvModal.hide(this.idModal);
      }
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.clientegrupocomercialnome === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-tabs content-class="mt-2" justified pills>
        <b-tab active title="Representante">
          <TabRepresentante
              :value="value"/>
        </b-tab>
        <b-tab title="Cliente">
          <TabCliente
            :value="value"/>
        </b-tab>
        <b-tab title="Endereco">
          <TabEndereco
              :value="value"/>
        </b-tab>
        <b-tab title="Contato">
          <TabContato
              :value="value"/>
        </b-tab>
        <b-tab title="Comercial">
          <TabComercial
              :value="value"/>
        </b-tab>
        <b-tab title="Fiscal">
          <TabFiscal
              :value="value"/>
        </b-tab>
<!--        <b-tab title="Documentos">-->
<!--          <TabDocumento-->
<!--              :value="value"/>-->
<!--        </b-tab>-->
      </b-tabs>
    </validation-observer>
  </b-modal>
</template>
